export default "__VITE_ASSET__CmeE2tZe__"